import { Helmet } from "react-helmet";
import { createBrowserRouter } from "react-router";
import About from "./Page/About";
import Home from "./Page/Home";
import NotFound from "./Page/NotFound";
import Practice from "./Page/Practice";
import Services from "./Page/Services";
import Work from "./Page/Work";
import Root from "./Root";
import AssignmentPage from "./Sub-Page/AssignmentPage";
import Career from "./Sub-Page/Career";
import BlockPage from "./Sub-Page/Home/Blog";
import PracticeChild from "./Sub-Page/Practice/PracticeChild";
import Child_Organization_Development from "./Sub-Page/Services/Child_Organization_Development/Child_Organization_Development";
import Organization_Development from "./Sub-Page/Services/Organization_Development";
import Reacher_Evaluation from "./Sub-Page/Services/Research_Evaluation";
import Team from "./Sub-Page/Team";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title>Home - CBSG</title>
          <meta name="description" content="Welcome to the CBSG homepage." />
          <meta name="keywords" content="CBSG, homepage, capacity building, consulting, development, research, evaluation, services, projects, team, careers, organization, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
          <meta name="author" content="CBSG Team" />
        </Helmet>
        <Root />
      </>
    ),
    errorElement: <NotFound />,
    children: [
      {
        path: "/",
        element: (
          <>
            <Helmet>
              <title>Home - CBSG</title>
              <meta name="description" content="Welcome to the CBSG homepage." />
              <meta name="keywords" content="CBSG, homepage, capacity building, consulting, development, research, evaluation, services, projects, team, careers, organization, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Home />
          </>
        ),
      },
      {
        path: "/About",
        element: (
          <>
            <Helmet>
              <title>About Us - CBSG</title>
              <meta name="description" content="Learn more about CBSG." />
              <meta name="keywords" content="CBSG, about, company information, history, mission, vision, values, leadership, team, expertise, experience, innovation, solutions, impact, community, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <About />
          </>
        ),
      },
      {
        path: "/blog/:id",
        element: (
          <>
            <Helmet>
              <title>Blog - CBSG</title>
              <meta name="description" content="Read our latest blog posts." />
              <meta name="keywords" content="CBSG, blog, articles, insights, updates, news, research, evaluation, services, projects, team, careers, organization, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <BlockPage />
          </>
        ),
      },
      {
        path: "/Services",
        element: (
          <>
            <Helmet>
              <title>Services - CBSG</title>
              <meta name="description" content="Explore our services." />
              <meta name="keywords" content="CBSG, services, capacity building, consulting, development, research, evaluation, projects, team, careers, organization, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Services />
          </>
        ),
      },
      {
        path: "/Services/Research&Evaluation",
        element: (
          <>
            <Helmet>
              <title>Research & Evaluation - CBSG</title>
              <meta name="description" content="Research and evaluation services." />
              <meta name="keywords" content="CBSG, research, evaluation, analysis, data, insights, projects, team, careers, organization, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Reacher_Evaluation />
          </>
        ),
        children: [
          {
            path: "/Services/Research&Evaluation/:Subpath",
            loader: ({ params }) => {
              return params.Subpath;
            },
            errorElement: <div>Sorry Content Not found</div>,
            element: (
              <>
                <Helmet>
                  <title>Research & Evaluation Details - CBSG</title>
                  <meta name="description" content="Details of our research and evaluation services." />
                  <meta name="keywords" content="CBSG, research details, evaluation details, analysis, data, insights, projects, team, careers, organization, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
                  <meta name="author" content="CBSG Team" />
                </Helmet>
                <Child_Organization_Development />
              </>
            ),
          },
        ],
      },
      {
        path: "/Services/Organization-Development",
        element: (
          <>
            <Helmet>
              <title>Organization Development - CBSG</title>
              <meta name="description" content="Organization development services." />
              <meta name="keywords" content="CBSG, organization development, consulting, strategy, growth, projects, team, careers, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Organization_Development />
          </>
        ),
      },
      {
        path: "/Services/Organization-Development/:id",
        element: (
          <>
            <Helmet>
              <title>Organization Development Details - CBSG</title>
              <meta name="description" content="Details of our organization development services." />
              <meta name="keywords" content="CBSG, organization development details, consulting, strategy, growth, projects, team, careers, practice areas, global reach, expertise, innovation, solutions, impact, community, leadership, sustainability, collaboration, excellence, integrity, commitment, inclusivity, adaptability" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Child_Organization_Development />
          </>
        ),
      },
      {
        path: "/practice-areas",
        element: (
          <>
            <Helmet>
              <title>Practice Areas - CBSG</title>
              <meta name="description" content="Explore our practice areas." />
              <meta name="keywords" content="CBSG, practice areas, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability, consulting, development, research, evaluation, projects, team, careers, organization, global reach" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Practice />
          </>
        ),
      },
      {
        path: "/practice-areas/:id",
        element: (
          <>
            <Helmet>
              <title>Practice Area Details - CBSG</title>
              <meta name="description" content="Details of our practice areas." />
              <meta name="keywords" content="CBSG, practice area details, expertise, innovation, solutions, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability, consulting, development, research, evaluation, projects, team, careers, organization, global reach" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <PracticeChild />
          </>
        ),
      },
      {
        path: "/team-career/team",
        element: (
          <>
            <Helmet>
              <title>Our Team - CBSG</title>
              <meta name="description" content="Meet our team." />
              <meta name="keywords" content="CBSG, team, members, expertise, experience, leadership, innovation, solutions, impact, community, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability, consulting, development, research, evaluation, projects, careers, organization, practice areas, global reach" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Team />
          </>
        ),
      },
      {
        path: "/team-career/career",
        element: (
          <>
            <Helmet>
              <title>Careers - CBSG</title>
              <meta name="description" content="Join our team." />
              <meta name="keywords" content="CBSG, careers, jobs, opportunities, growth, development, team, members, expertise, experience, leadership, innovation, solutions, impact, community, sustainability, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability, consulting, research, evaluation, projects, organization, practice areas, global reach" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Career />
          </>
        ),
      },
      {
          path: "/work-reach",
        element: (
          <>
            <Helmet>
              <title>Work & Reach - CBSG</title>
              <meta name="description" content="Our work and reach." />
              <meta name="keywords" content="CBSG, work, reach, projects, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability, consulting, development, research, evaluation, team, careers, organization, practice areas, global reach" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <Work />
          </>
        ),
      },
      {
        path: "assignments/:id",
        element: (
          <>
            <Helmet>
              <title>Assignment Details - CBSG</title>
              <meta name="description" content="Details of specific assignments." />
              <meta name="keywords" content="CBSG, assignments, details, projects, impact, community, leadership, sustainability, growth, strategy, collaboration, excellence, integrity, commitment, inclusivity, adaptability, consulting, development, research, evaluation, team, careers, organization, practice areas, global reach" />
              <meta name="author" content="CBSG Team" />
            </Helmet>
            <AssignmentPage />
          </>
        ),
      },
      {
        path: "*",
        element: <NotFound />
      }
    ],
  },
]);

export default router;
